<template>
  <div>
    <div class="store_header">
      <div class="page_info">
        <div class="logo_img">
          <router-link
            :to="{ name: 'appstore', params: { marketID: marketInfo.domain } }"
          >
            <img :src="logoImg" alt />
          </router-link>
        </div>
        <div class="desc">
          <p class="page_name" v-if="marketInfo">{{ marketInfo.name }}</p>
          <p class="page_name" v-else><span>应用</span>市场</p>
          <p class="tips">Rainstore ISV应用商店</p>
        </div>
      </div>
      <div class="search_box">
        <el-input
          v-model="searchQuery"
          placeholder="应用名称"
          class="search_input"
          @keyup.enter.native="keywordChange"
          @blur="keywordChange"
        ></el-input>
        <el-button class="search_btn" @click="searchApp">搜索</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import logoImg from '@/assets/images/logo.svg';

export default {
  data() {
    return {
      logoImg,
      searchQuery: ''
    };
  },
  props: ['queryName', 'marketInfo'],
  created() {
    this.searchQuery = this.queryName;
  },
  methods: {
    keywordChange() {
      this.$parent.queryChange(
        this.searchQuery == undefined ? '' : this.searchQuery
      );
      this.$parent.getAppList();
    },
    searchApp() {
      this.$parent.getAppList();
    }
  }
};
</script>
<style lang="scss" scoped>
.store_header {
  width: 1200px;
  margin: 32px auto 25px;
  display: flex;
  align-items: center;
  .page_info {
    width: 250px;
    display: flex;
    align-items: center;
    .logo_img {
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      padding: 0 5px;
      height: 40px;
      border-radius: 4px;
      margin-right: 10px;
      img {
        width: 50px;
        height: 100%;
      }
    }
    .desc {
      width: 200px;
      .page_name {
        color: #54585a;
        font-size: 16px;
        margin: 0;
        span {
          color: #1890ff;
        }
      }
      .tips {
        margin: 0;
        font-size: 14px;
        color: rgba(84, 88, 90, 0.7);
      }
    }
  }
  .search_box {
    display: flex;
    flex: 1;
    margin-left: 20px;
    .search_btn {
      background-color: #1890ff;
      color: #fff;
      border-radius: initial;
      border: none;
      width: 140px;
    }
  }
}

::v-deep .search_input {
  .el-input__inner {
    border: none;
    border-radius: initial;
  }
}

.banner_box {
  height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/views/appstore/components/shufflingSearch.vue